import { useLocation, useNavigate, useOutletContext } from 'react-router'
import { RxCross2 } from 'react-icons/rx'

import { useGetUserWithUserNameQuery } from '../../services/apiSlice'
import { CurrentUser } from '../../services/schema/User'
import Spinner from '../../components/loading/Spinner'
import NotFoundMedia from '../../components/fallback/NotFoundMedia'

const UserMedia: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const user = useOutletContext<CurrentUser>()

  if (location.search === '') {
    return <NotFoundMedia />
  }

  const mediaRoute = location.pathname.split('/')[2]
  const username = location.search.split('=')[1]

  if (!username) {
    return <NotFoundMedia />
  }

  const { data, isLoading, isError } = useGetUserWithUserNameQuery(
    {
      username: username,
    },
    { skip: username === user.username },
  )

  if (isLoading) {
    return (
      <div className="bgd-theme flex h-dvh w-dvw items-center justify-center">
        <Spinner />
      </div>
    )
  }

  if (!data && isError) {
    return <NotFoundMedia />
  }

  const userToShow = user.username !== username ? data : user

  if (userToShow) {
    const profilePic =
      userToShow.profilePicture !== null
        ? userToShow.profilePicture
        : '/user_sample.jpg'
    const headerPic =
      userToShow.headerPicture !== null ? userToShow.headerPicture : null

    if (mediaRoute === 'profilePicture') {
      const inline = {
        backgroundImage: 'url(' + profilePic + ')',
      }
      return (
        <div className="bgd-theme fixed flex h-dvh w-dvw items-center justify-center">
          <div className="relative flex h-dvh w-[10%] items-center justify-center text-2xl">
            <button
              type="button"
              className="hover-sub absolute top-[10px] left-[10px] flex cursor-pointer items-center justify-center rounded-full p-[10px] text-3xl"
              onClick={() => {
                navigate(`/${userToShow.username}`)
              }}
            >
              <RxCross2 />
            </button>
          </div>
          <div className="relative flex h-dvh w-[90%]">
            <div className="absolute flex h-full w-full items-center justify-center object-contain">
              <div className="relative h-full w-full">
                <div
                  style={inline}
                  className="absolute inset-x-0 inset-y-0 h-full w-full min-w-0 rounded-[30px] bg-contain bg-center bg-no-repeat"
                />
                <img
                  className="absolute inset-x-0 inset-y-0 h-full w-full min-w-0 rounded-[30px] opacity-0"
                  src={profilePic}
                  alt={`${userToShow.username}'s profile picture`}
                />
              </div>
            </div>
          </div>
          <div className="flex h-dvh w-[10%]"></div>
        </div>
      )
    } else if (mediaRoute === 'headerPicture') {
      if (headerPic) {
        const inline = {
          backgroundImage: 'url(' + headerPic + ')',
        }
        return (
          <div className="bgd-theme fixed flex h-dvh w-dvw items-center justify-center">
            <div className="relative flex h-dvh w-[10%] items-center justify-center text-2xl">
              <button
                type="button"
                className="hover-sub absolute top-[10px] left-[10px] flex cursor-pointer items-center justify-center rounded-full p-[10px] text-3xl"
                onClick={() => {
                  navigate(`/${userToShow.username}`)
                }}
              >
                <RxCross2 />
              </button>
            </div>
            <div className="relative flex h-dvh w-[90%]">
              <div className="absolute flex h-full w-full items-center justify-center object-contain">
                <div className="relative h-full w-full">
                  <div
                    style={inline}
                    className="absolute inset-x-0 inset-y-0 h-full w-full min-w-0 rounded-[30px] bg-contain bg-center bg-no-repeat"
                  />
                  <img
                    className="absolute inset-x-0 inset-y-0 h-full w-full min-w-0 rounded-[30px] opacity-0"
                    src={profilePic}
                    alt={`${userToShow.username}'s header picture`}
                  />
                </div>
              </div>
            </div>
            <div className="flex h-dvh w-[10%]"></div>
          </div>
        )
      } else {
        const inline = {
          backgroundColor: 'gray',
        }
        return (
          <div className="bgd-theme fixed flex h-dvh w-dvw items-center justify-center">
            <div className="relative flex h-dvh w-[10%] items-center justify-center text-2xl">
              <button
                type="button"
                className="hover-sub absolute top-[10px] left-[10px] flex cursor-pointer items-center justify-center rounded-full p-[10px] text-3xl"
                onClick={() => {
                  navigate(`/${userToShow.username}`)
                }}
              >
                <RxCross2 />
              </button>
            </div>
            <div className="relative flex h-dvh w-[90%]">
              <div className="absolute flex h-full w-full items-center justify-center object-contain">
                <div className="relative h-full w-full">
                  <div
                    style={inline}
                    className="absolute inset-x-0 inset-y-0 h-full w-full min-w-0 rounded-[30px] bg-contain bg-center bg-no-repeat"
                  />
                </div>
              </div>
            </div>
            <div className="flex h-dvh w-[10%]"></div>
          </div>
        )
      }
    }
  }
}

export default UserMedia
